import { render, staticRenderFns } from "./SupplierInvoiceList.vue?vue&type=template&id=9afa716e&scoped=true"
import script from "./SupplierInvoiceList.vue?vue&type=script&lang=js"
export * from "./SupplierInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afa716e",
  null
  
)

export default component.exports